import { Component, OnInit, inject } from '@angular/core';
import { MicrosoftLoginProvider, SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { SocialLoginComponent } from './social-login/social-login.component';
import { ToastrService } from 'ngx-toastr';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { InLineErrorMessages } from '../_shared/constants/error-messages.constant';
import { ErrorHandlerService } from '../_shared/services/error-handler.service';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../_shared/services/auth.service';
import { BlockUI, BlockUIModule, NgBlockUI } from 'ng-block-ui';
import { ForgotPasswordFormComponent } from './forgot-password-form/forgot-password-form.component';
import { LoginFormComponent } from './login-form/login-form.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    SocialLoginComponent,
    LoginFormComponent,
    ForgotPasswordFormComponent,
    BlockUIModule,
    TranslocoModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  private readonly transloco = inject(TranslocoService);
  private readonly errorHandler = inject(ErrorHandlerService);
  @BlockUI() blockUI!: NgBlockUI;

  isLoggingIn: boolean = false;
  forgotPasswordFormEnabled: boolean = false;
  inlineErrorMessage: string;

  constructor(
    private socialAuthService: SocialAuthService,
    private authService: AuthService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.initListener();
  }

  private initListener(): void {
    this.socialAuthService.authState
      .subscribe(this.externalSignIn.bind(this));
  }

  public signInWithGoogle(e: any): void {
    this.isLoggingIn = true;
    e.click();
  }

  signInWithMicrosoft(e: any): void {
    this.isLoggingIn = true;
    this.socialAuthService.signIn(MicrosoftLoginProvider.PROVIDER_ID);
  }

  async externalSignIn(user: SocialUser): Promise<void> {
    this.blockUI.start();
    if (this.isLoggingIn && user && user.idToken) {
      try {
        const response = await firstValueFrom(this.authService.externalLogin(user.idToken, user.provider));
        if (response.data || !response.errorCode) {
          this.authService.setUser(response.data!);
          this.authService.redirectUrl = '/authenticate'
          this.authService.redirect();
        }
      } catch(error: any) {
        console.error(error);
        this.handleError(error);
        this.blockUI.stop();
      }
    } else {
      window.location.reload();
    }

    this.blockUI.stop();
  }

  public toggleForgotPassword(toggle: boolean): void {
    this.forgotPasswordFormEnabled = toggle;
    this.inlineErrorMessage = '';
  }

  private handleError(error: any): void {
    const code = error?.error?.errorCode;
    this.inlineErrorMessage = InLineErrorMessages[code] ? this.transloco.translate(`inlineErrorMessages.${code}`) : '';
    if (!this.inlineErrorMessage) {
      const message = this.errorHandler.getMessage(code) || this.transloco.translate('login.loginError');
      this.toastr.error(message);
    }
  }
}
